import { useState, useEffect, useRef } from 'react'

// 用原生 fetch 加载需要鉴权的图片，返回 blob URL
// 避免用 axios（拦截器会把 blob 响应误判为 302 导致登出）
async function fetchImageBlob(url: string): Promise<string> {
  if (!url) return ''
  try {
    const cookie = localStorage.getItem('cookie') || ''
    const res = await fetch(url, {
      credentials: 'include',
      headers: cookie ? { Cookie: cookie } : {},
    })
    if (!res.ok) return ''
    const blob = await res.blob()
    return URL.createObjectURL(blob)
  } catch {
    return ''
  }
}

export function useAvatarSrc(avatarUrl?: string) {
  const [src, setSrc] = useState('')
  const prevBlobRef = useRef('')

  useEffect(() => {
    if (!avatarUrl) {
      if (prevBlobRef.current) {
        URL.revokeObjectURL(prevBlobRef.current)
        prevBlobRef.current = ''
      }
      setSrc('')
      return
    }

    // 如果已经是 blob: 或 data: URL，直接用
    if (avatarUrl.startsWith('blob:') || avatarUrl.startsWith('data:')) {
      setSrc(avatarUrl)
      return
    }

    let cancelled = false
    fetchImageBlob(avatarUrl).then((blobUrl) => {
      if (cancelled) return
      if (prevBlobRef.current) URL.revokeObjectURL(prevBlobRef.current)
      prevBlobRef.current = blobUrl
      setSrc(blobUrl)
    })

    return () => { cancelled = true }
  }, [avatarUrl])

  return src
}
